import { render, staticRenderFns } from "./CardSectionProperties.vue?vue&type=template&id=310cbffe&"
import script from "./CardSectionProperties.vue?vue&type=script&lang=js&"
export * from "./CardSectionProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCardSection,QItem} from 'quasar'
component.options.components = Object.assign({QCardSection,QItem}, component.options.components || {})
